import React, { useContext, useEffect, useState } from 'react';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { RedContext } from '../../context/connection/ContextRed';
import { UserContext } from '../../context/user/ContextUser';
const initialState = {
    id: '',
    id_user: 0,
    nombre: '',
    sueldo: '',
    direccion: '',
    telefono: '',
    inicio_labores: '',
    estado: true,
    vale: false,
};

export const AddEmploye = ({ show, onClose, item, callBk }) => {
    const { setResp } = useContextInfo();
    const { redState } = useContext(RedContext);
    const { usersState } = useContext(UserContext);

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);

    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...item });
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`nominas/employe`, { ...values }, 'POST');
            setResp(res);
            callBk();
            reset();
            onClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose} size="lg">
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title"> {id ? 'Editar' : 'Nuevo'} Empleado</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>Nombre</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Nombre"
                                                        value={values.nombre}
                                                        name="nombre"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>{' '}
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom003">
                                                    <Form.Label>Agente asociado</Form.Label>
                                                    <Form.Select
                                                        value={values.id_user}
                                                        name="id_user"
                                                        onChange={handleInputChange}>
                                                        <option value={0} disabled selected>
                                                            Seleccionar...
                                                        </option>
                                                        {usersState.agentes.map((mk, i) => (
                                                            <option value={mk.id_agent} key={i}>
                                                                {mk.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom004">
                                                    <Form.Label>Teléfono</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.telefono}
                                                        name="telefono"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                        </Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom003">
                                                <Form.Label>Dirección</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={values.direccion}
                                                    name="direccion"
                                                    required
                                                    onChange={handleInputChange}
                                                />
                                            </Form.Group>
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                        </Col>{' '}
                                        <Row>
                                            <Col xs lg="3">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Salario por dia</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.sueldo}
                                                        name="sueldo"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una cantidad
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col xs lg="3">
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Inicio de labores</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        value={values.inicio_labores}
                                                        name="inicio_labores"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una facha
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom17">
                                                    <Form.Label>Estado</Form.Label>
                                                    <Form.Select
                                                        value={values.estado}
                                                        name="estado"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value={true}>Activo</option>
                                                        <option value={false}>Desactivado</option>
                                                    </Form.Select>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom17">
                                                    <Form.Label>Vale de despensa</Form.Label>
                                                    <Form.Select
                                                        value={values.vale}
                                                        name="vale"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value={true}>Activo</option>
                                                        <option value={false}>Desactivado</option>
                                                    </Form.Select>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};
